import React from "react";
import Cookies from "universal-cookie";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";

import withAuth from "../../hoc/withAuth";
import MainLayout from "../../components/layouts/MainLayout";

import { otodisService } from "../../services/OtodisService";

import { Form, DatePicker, Input, Table, Button, Modal, Row, Col, Space, Tooltip, Select, Switch } from "antd";
import { SearchOutlined, ExportOutlined, CopyOutlined } from "@ant-design/icons";

import SelectDealer from "../../components/selects/SelectDealer";
import ModalDetailBBN from "../../components/modal/ModalDetailBBN";
import ModalHandoverDocument from "../../components/modal/ModalHandoverDocument";

class MonitoringDocument extends React.Component {
  token = new Cookies().get("_bbn_tn");
  tableColumn = [
    {
      title: "Aksi",
      key: "aksi",
      width: 100,
      render: (value, row) => {
        const bpkbEntryDate = row.vehicle_certificate_of_ownership_entry_date;

        const showUploadBpkb = bpkbEntryDate === "NONE";

        if (showUploadBpkb) {
          return (
            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <div
                onClick={(event) => this.navigateToUploadBpkb(row)}
                style={{
                  display: "inline-block",
                  padding: "2px 6px",
                  fontSize: "90%",
                  backgroundColor: "#f0f9ff",
                  color: "#1784b8",
                  border: "1px solid #91d5ff",
                  borderRadius: "4px",
                  cursor: "pointer",
                  textAlign: "center",
                }}
              >
                Upload BPKB
              </div>
            </div>
          );
        } else {
          return null;
        }
      },
    },
    {
      title: "Kode Order",
      dataIndex: "order_code",
      key: "order_code",
      width: 210,
      ellipsis: true,
      render: (value, row) => {
        return (
          <React.Fragment>
            <span className={`font-90-link`} onClick={(event) => this.showDetail(row)}>
              {value}
              &nbsp;
              <Tooltip title="Click untuk copy kode order" color={"cyan"}>
                <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)} />
              </Tooltip>
            </span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Nama Konsumen",
      dataIndex: "customer_doc_name",
      key: "customer_doc_name",
      width: 120,
    },
    {
      title: "Tgl Penugasan",
      dataIndex: "create_date",
      key: "create_date",
      width: 110,
    },
    {
      title: "Usia",
      dataIndex: "create_date",
      key: "usia_order",
      width: 80,
      ellipsis: true,
      render: (value) => {
        const usia = dayjs().diff(dayjs(value), "days");
        return `${usia} hari`;
      },
      sorter: (a, b) => {
        const usiaA = dayjs().diff(dayjs(a.create_date), "days");
        const usiaB = dayjs().diff(dayjs(b.create_date), "days");
        return usiaA - usiaB;
      },
    },
    {
      title: "No Mesin",
      dataIndex: "vehicle_engine_number",
      key: "vehicle_engine_number",
      width: 110,
      ellipsis: true,
      render: (value, row) => {
        return (
          <React.Fragment>
            <span>
              {value}
              &nbsp;
              <Tooltip title="Click untuk copy kode order" color={"cyan"}>
                <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)} />
              </Tooltip>
            </span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Variant Kendaraan",
      dataIndex: "vehicle_variant_name",
      key: "vehicle_variant_name",
      width: 120,
    },
    {
      title: "Status BBN",
      dataIndex: "transfer_title_status",
      key: "transfer_title_status",
      width: 90,
    },
    {
      title: "No Polisi",
      dataIndex: "vehicle_license_plate",
      key: "vehicle_license_plate",
      width: 100,
    },
    {
      title: "No BPKB",
      dataIndex: "vehicle_certificate_of_ownership_number",
      key: "vehicle_certificate_of_ownership_number",
      width: 100,
    },
    {
      title: "Tgl BPKB Masuk",
      dataIndex: "vehicle_certificate_of_ownership_entry_date",
      key: "vehicle_certificate_of_ownership_entry_date",
      width: 110,
    },
    {
      title: "Tgl BPKB Keluar",
      dataIndex: "vehicle_certificate_of_ownership_submission_date",
      key: "vehicle_certificate_of_ownership_submission_date",
      width: 110,
    },

    {
      title: "No Notice",
      dataIndex: "vehicle_notice_number",
      key: "vehicle_notice_number",
      width: 100,
    },
    {
      title: "Tgl Notice Masuk",
      dataIndex: "vehicle_notice_entry_date",
      key: "vehicle_notice_entry_date",
      width: 110,
    },
    {
      title: "Tgl Notice Keluar",
      dataIndex: "vehicle_notice_submission_date",
      key: "vehicle_notice_submission_date",
      width: 110,
      render: (value, row) => {
        return `${value?.slice(0, -5)}`;
      },
    },
    {
      title: "No STNK",
      dataIndex: "vehicle_registration_certificate_number",
      key: "vehicle_registration_certificate_number",
      width: 100,
    },
    {
      title: "Tgl STNK Masuk",
      dataIndex: "vehicle_registration_certificate_entry_date",
      key: "vehicle_registration_certificate_entry_date",
      width: 110,
    },
    {
      title: "Tgl STNK Keluar",
      dataIndex: "vehicle_registration_certificate_submission_date",
      key: "vehicle_registration_certificate_submission_date",
      width: 110,
      render: (value, row) => {
        return `${value?.slice(0, -5)}`;
      },
    },
  ];

  generateFileCsv = React.createRef();
  constructor(props) {
    super(props);

    const { match } = this.props;
    const code_svb = match.params.code_svb;

    this.initState = {
      code_svb: code_svb,
      processing: false,
      processingFetchTableData: false,
      pageSize: 100,

      dataOrder: [],
      filterType: "ENGINE_NUMBER",
      filterEngineNumber: "",
      filterStatusBbn: "",
      filterDealer: "",
      filterDate: "",
      filterStatusBpkb: "false",

      loadingButton: false,
      tableSelectedRowKeys: [],
      dataExport: [],
      rowDetailOrder: [],
      showModalDetailOrder: false,
      showModalHandoverDocument: false,
    };

    this.state = { ...this.initState };
  }

  handleToggleColumn = (category) => {
    this.setState((prevState) => ({
      [`show${category.charAt(0).toUpperCase() + category.slice(1)}`]: !prevState[`show${category.charAt(0).toUpperCase() + category.slice(1)}`],
    }));
  };

  tableGetVisibleColumnsWidth = () => {
    const visibleColumns = this.tableColumn;
    return visibleColumns.reduce((total, col) => {
      return total + (col.width || 120); // fallback default width
    }, 0);
  };

  copyToClipboard = async (data) => {
    await navigator.clipboard.writeText(data);
  };

  handleFieldChange = (field, value) => {
    this.setState({ [field]: value });

    if (field === "filterType") {
      this.setState({ filterEngineNumber: "" });
    }
  };

  changeFilterDate = (date, dateString) => {
    this.setState({
      filterDate: dateString,
    });
  };

  closeModalDetailOrder = (data) => {
    this.setState({
      showModalDetailOrder: false,
    });
  };

  showDetail = (data) => {
    this.setState({
      rowDetailOrder: data,
      showModalDetailOrder: true,
    });
  };

  closeModalHandoverDocument = () => {
    this.setState({
      showModalHandoverDocument: false,
    });
  };

  navigateToUploadBpkb = (row) => {
    // Navigate to Upload BPKB page
    const { history } = this.props;
    const { code_svb } = this.state;
    history.push(`/${code_svb}/dokumen/bpkb/upload`);
  };

  showModalHandoverDocument = (data) => {
    // Handle both single order (from parameter) and multiple orders (from selection)
    let ordersToProcess;

    if (data) {
      // Single order passed as parameter
      ordersToProcess = data;
    } else {
      // Multiple orders from table selection
      const selectedRows = this.state.tableSelectedRowKeys;
      if (!selectedRows || selectedRows.length === 0) {
        Modal.error({
          title: "Validation Error",
          content: "Tidak Ada Data yang Dipilih untuk Handover Dokumen",
        });
        return;
      }
      ordersToProcess = selectedRows;
    }

    this.setState({
      rowDetailOrder: ordersToProcess,
      showModalHandoverDocument: true,
    });
  };

  fetchDataOrder = async () => {
    try {
      const filter = this.state;

      if (!filter.filterEngineNumber) {
        if (!filter.filterStatusBbn) {
          throw new Error("Status is Required");
        } else {
          if (!filter.filterDate && !filter.filterEngineNumber && filter.filterStatusBbn === "GENERATED") {
            throw new Error("Date is Required");
          }
        }
      }

      this.setState({
        processingFetchTableData: true,
        loadingButton: true,
      });

      const params = {};

      params.service_bureau_code = this.state.code_svb;
      if (filter.filterEngineNumber !== "") {
        params.vehicle_engine_number = filter.filterEngineNumber;
      } else {
        if (filter.filterStatusBbn !== "") {
          params.transfer_title_status = filter.filterStatusBbn;
        }
        if (filter.filterDealer !== "") {
          params.dealer_code = filter.filterDealer;
        }

        if (filter.filterDate !== "") {
          params.date_start = dayjs(filter.filterDate).clone().startOf("month").format("YYYY-MM-DD");
          params.date_end = dayjs(filter.filterDate).clone().endOf("month").format("YYYY-MM-DD");
        }

        if (filter.filterStatusBpkb) {
          params.bpkb_handover_status = filter.filterStatusBpkb;
        }
      }

      // console.log("params", params);
      otodisService.setToken(this.token);
      const dataOrder = await otodisService.getAssignedOrder(params);
      // console.log(dataOrder.data.success.data);

      this.setState({
        dataOrder: dataOrder.data.success.data,
        processingFetchTableData: false,
        loadingButton: false,
        tableSelectedRowKeys: [],
      });
    } catch (error) {
      this.setState({
        dataOrder: [],
        processingFetchTableData: false,
        loadingButton: false,
        tableSelectedRowKeys: [],
      });
      Modal.error({
        title: "Validation Error",
        content: error.message,
      });
      return false;
    }
  };

  onClickFilter = async () => {
    await this.fetchDataOrder();
  };

  onClickExport = async () => {
    const selectedRows = this.state.tableSelectedRowKeys;
    if (!selectedRows || selectedRows.length === 0) {
      Modal.error({
        title: "Validation Error",
        content: "Tidak Ada Data yang Dipilih",
      });
      return;
    }

    const headers = this.tableColumn.map((col) => col.title);
    const rows = [];

    selectedRows.forEach((row) => {
      const rowData = this.tableColumn.map((col) => {
        const dataIndex = col.dataIndex;
        const render = col.render;
        let value;

        if (dataIndex === "order_code") {
          value = row.order_code;
        } else if (dataIndex === "vehicle_engine_number") {
          value = row.vehicle_engine_number;
        } else if (dataIndex === "vehicle_registration_certificate_entry_date") {
          value = `IN: ${row.vehicle_registration_certificate_entry_date?.slice(0, -5) || ""} - OUT: ${row.vehicle_registration_certificate_submission_date?.slice(0, -5) || ""}`;
        } else if (dataIndex === "vehicle_certificate_of_ownership_entry_date") {
          value = `IN: ${row.vehicle_certificate_of_ownership_entry_date?.slice(0, -5) || ""} - OUT: ${row.vehicle_certificate_of_ownership_submission_date?.slice(0, -5) || ""}`;
        } else {
          value = dataIndex
            ? dataIndex
                .toString()
                .split(".")
                .reduce((acc, curr) => (acc ? acc[curr] : undefined), row)
            : undefined;

          if (render && typeof render === "function") {
            try {
              value = render(value, row);
              if (typeof value === "object" && value !== null && !Array.isArray(value)) {
                value = "";
              }
            } catch (err) {
              value = "";
            }
          }
        }

        return value ?? "";
      });

      rows.push(rowData);
    });

    const dataParsed = [headers, ...rows];

    this.setState({ loadingButton: true });

    try {
      await this.setState({
        dataExport: dataParsed,
      });

      this.generateFileCsv.current.link.click();

      this.setState({
        loadingButton: false,
      });
    } catch (error) {
      Modal.error({
        title: "Process Error",
        content: error.message,
      });
    }
  };

  onHandoverDocument = (updateData) => {
    // Handle both single and multi handover
    if (Array.isArray(updateData)) {
      // Multi handover - updateData is an array of updated rows
      const updateListOrder = this.state.dataOrder.map((item) => {
        const updatedItem = updateData.find((updated) => updated.order_code === item.order_code);
        if (updatedItem) {
          return {
            ...item,
            ...updatedItem,
          };
        }
        return item;
      });

      this.setState({
        rowDetailOrder: updateData,
        dataOrder: updateListOrder,
      });
    } else {
      // Single handover - updateData is a single row object
      const updateListOrder = this.state.dataOrder.map((item) => {
        if (item.order_code === updateData.order_code) {
          return {
            ...item,
            ...updateData,
          };
        }
        return item;
      });

      this.setState({
        rowDetailOrder: updateData,
        dataOrder: updateListOrder,
      });
    }
  };

  renderToggleSwitch = (key, label, stateKey) => {
    return (
      <div>
        <Switch className="custom-switch" checked={this.state[stateKey]} onChange={() => this.handleToggleColumn(key)} checkedChildren={`Tampil ${label}`} unCheckedChildren={`Tidak Tampil ${label}`} />
      </div>
    );
  };

  render() {
    const rowTableSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({
          tableSelectedRowKeys: selectedRows,
        });
      },
    };
    return (
      <React.Fragment>
        <MainLayout defaultOpenKeys={["2monitoringdata"]} defaultSelectedKeys={["5monitoringdokumen"]}>
          <div style={{ padding: 10, margin: 10, background: "#FFF" }}>
            <strong style={{ float: "right" }}>Monitoring Dokumen</strong>
            <Form name="form-filter" layout="vertical" style={{ padding: 8 }}>
              <Row>
                <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                  <Form.Item label="Cari Menggunakan">
                    <Select value={this.state.filterType} onChange={(value) => this.handleFieldChange("filterType", value)} placeholder="Select Type Filter">
                      <Select.Option key="ENGINE_NUMBER">Nomor Mesin</Select.Option>
                      <Select.Option key="CUSTOM_FILTER">Custom Filter</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                {this.state.filterType === "ENGINE_NUMBER" && (
                  <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                    <Form.Item label="Nomor Mesin">
                      <Input value={this.state.filterEngineNumber} onChange={(event) => this.handleFieldChange("filterEngineNumber", event.target.value)} />
                    </Form.Item>
                  </Col>
                )}
                {this.state.filterType === "CUSTOM_FILTER" && (
                  <React.Fragment>
                    <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                      <Form.Item label="Status BBN">
                        <Select value={this.state.filterStatusBbn} onChange={(value) => this.handleFieldChange("filterStatusBbn", value)} placeholder="Pilih Status">
                          <Select.Option key="INPUTED" value="INPUTED">
                            INPUTED
                          </Select.Option>
                          <Select.Option key="UPLOADED" value="UPLOADED">
                            BELUM LUNAS
                          </Select.Option>
                          <Select.Option key="PAID" value="GENERATED">
                            SUDAH LUNAS
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 300 }}>
                      <SelectDealer value={this.state.filterDealer} onChangeValue={(value) => this.handleFieldChange("filterDealer", value)} />
                    </Col>

                    <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                      <Form.Item label="Tanggal Order">
                        <DatePicker onChange={this.changeFilterDate} picker="month" />
                      </Form.Item>
                    </Col>

                    <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                      <Form.Item label="Status BPKB">
                        <Select value={this.state.filterStatusBpkb} onChange={(value) => this.handleFieldChange("filterStatusBpkb", value)} placeholder="Pilih Status">
                          <Select.Option key="none" value="false">
                            BELUM HANDOVER
                          </Select.Option>
                          <Select.Option key="UPLOADED" value="true">
                            SUDAH HANDOVER
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  </React.Fragment>
                )}
                <Col style={{ paddingLeft: 2, paddingRight: 2 }}>
                  <Form.Item label="&nbsp;">
                    <Space.Compact style={{ width: "100%" }}>
                      <Button onClick={this.onClickFilter} type="primary" icon={<SearchOutlined />} title="filter" style={{ minWidth: "33%", background: "#1784b8", borderColor: "#1784b8" }} loading={this.state.loadingButton}>
                        Filter
                      </Button>
                      &nbsp;
                      <Button onClick={this.onClickExport} type="primary" icon={<ExportOutlined />} title="export excel" style={{ minWidth: "33%", background: "#17a2b8", borderColor: "#17a2b8" }} loading={this.state.loadingButton}>
                        Export
                      </Button>
                      &nbsp;
                      <Button onClick={() => this.showModalHandoverDocument()} type="primary" title="handover dokumen" style={{ background: "#17a2b8", borderColor: "#17a2b8" }} loading={this.state.loadingButton}>
                        Handover Dokumen
                      </Button>
                    </Space.Compact>
                  </Form.Item>
                </Col>
              </Row>
            </Form>

            <CSVLink data={this.state.dataExport} filename="data-order.csv" ref={this.generateFileCsv} target="_blank" style={{ display: "none" }}>
              Export
            </CSVLink>

            <Table
              rowSelection={rowTableSelection}
              scroll={{ x: this.tableGetVisibleColumnsWidth() }}
              rowKey={"order_code"}
              size={"small"}
              loading={this.state.processingFetchTableData}
              columns={this.tableColumn}
              dataSource={this.state.dataOrder}
              pagination={{ pageSize: this.state.pageSize }}
              onChange={this.onChangeTable}
              className="text-uppercase"
              style={{ fontSize: "10%" }}
            />
          </div>
          <ModalDetailBBN kodeOrder={"aaaa"} dataOrder={this.state.rowDetailOrder} visible={this.state.showModalDetailOrder} onClose={this.closeModalDetailOrder} />
          <ModalHandoverDocument dataOrder={this.state.rowDetailOrder} visible={this.state.showModalHandoverDocument} onClose={this.closeModalHandoverDocument} onSaveData={this.onHandoverDocument} />
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(MonitoringDocument);
